import { ReducerChain, withScope } from "@gamedev-web/gamedev-sdk-core";

import { PitchPageActions, PitchPageData } from "../actions/pitchPageActions";
import { PitchPageScope } from "../scopes";

export type PitchPageState = {
  isLoading: boolean;
  isSaving: boolean;
  isSubmitting: boolean;
  data: PitchPageData | null;
  error: string | null;
};

export const initialPitchPageState: PitchPageState = {
  isLoading: false,
  isSaving: false,
  isSubmitting: false,
  data: null,
  error: null,
};

export const pitchPageReducer = withScope(
  [PitchPageScope],
  new ReducerChain<PitchPageState>(initialPitchPageState)
    .on(PitchPageActions.FETCH_START, () => ({
      ...initialPitchPageState,
      isLoading: true,
    }))
    .on(PitchPageActions.FETCH_COMPLETED, (state, action) => ({
      ...state,
      isLoading: false,
      data: (action as unknown as { data: PitchPageData }).data,
      error: null,
    }))
    .on(PitchPageActions.FETCH_ERROR, (state, action) => ({
      ...state,
      isLoading: false,
      error: (action as unknown as { error: Error }).error.message,
    }))
    .on(PitchPageActions.SAVE_START, state => ({
      ...state,
      isSaving: true,
      error: null,
    }))
    .on(PitchPageActions.SAVE_COMPLETED, state => ({
      ...state,
      isSaving: false,
      error: null,
    }))
    .on(PitchPageActions.SAVE_ERROR, (state, action) => ({
      ...state,
      isSaving: false,
      error: (action as unknown as { error: Error }).error.message,
    }))
    .on(PitchPageActions.SUBMIT_START, state => ({
      ...state,
      isSubmitting: true,
      error: null,
    }))
    .on(PitchPageActions.SUBMIT_COMPLETED, state => ({
      ...state,
      isSubmitting: false,
      error: null,
    }))
    .on(PitchPageActions.SUBMIT_ERROR, (state, action) => ({
      ...state,
      isSubmitting: false,
      error: (action as unknown as { error: Error }).error.message,
    }))
    .build()
);
